export default __webpack_public_path__ + "00121ec5705909c5ff7e42ccb8d4e7ee.png";